import type { GenerationAttemptResource } from '@studio/shared';
import { useState, type ReactNode } from 'react';
import { api } from '../shell/api.js';

function costLine(attempt: GenerationAttemptResource): string {
  if (attempt.accounting === 'subscription') return 'По подписке; стоимость не учитывается';
  return attempt.actualUsd === null ? `оценка $${attempt.estimatedUsd ?? 0}` : `списано $${attempt.actualUsd}`;
}

/**
 * Everything technical about a slot, and nothing technical anywhere else. The gallery
 * carries one plain line; the provider, the model, the money and the references live
 * here, one disclosure away, and are read only when they are asked for.
 */
export function SlotDetails({ slotId }: { slotId: string }): ReactNode {
  const [open, setOpen] = useState(false);
  const [attempts, setAttempts] = useState<readonly GenerationAttemptResource[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="slot-details">
      <button
        type="button"
        className="ghost"
        aria-expanded={open}
        onClick={() => {
          const next = !open;
          setOpen(next);
          if (next && attempts === null) {
            void api
              .readAttempts(slotId)
              .then((response) => setAttempts(response.attempts))
              .catch(() => setError('Attempt этого слота не удалось прочитать.'));
          }
        }}
      >
        Детали
      </button>
      {!open ? null : error !== null ? (
        <p className="failure" role="alert">
          {error}
        </p>
      ) : attempts === null ? (
        <p className="note">Читаю Attempt…</p>
      ) : attempts.length === 0 ? (
        <p className="note">Для этого слота ни один Attempt провайдера не открывался.</p>
      ) : (
        <ul className="attempt-list">
          {attempts.map((attempt) => (
            <li key={attempt.id}>
              <span>{`${attempt.providerId} · ${attempt.modelId} · ${attempt.operation}`}</span>
              <span className="note">
                {`Attempt ${attempt.attemptNumber} (${attempt.reason}) · ${attempt.status} · ${costLine(attempt)}`}
              </span>
              {attempt.failureReason === null ? null : (
                <span className="note">{`${attempt.failureReason}: ${attempt.message ?? 'без сообщения'}`}</span>
              )}
              <span className="note">{`Ссылки: ${attempt.referenceArtifactIds.join(', ') || 'нет'}`}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
